import { useEffect } from "react";
import { useLocation } from "react-router-dom";

export default function ScrollToTop() {
  const { pathname, hash } = useLocation();

  useEffect(() => {
    // If the URL has a hash (#section), let the browser handle it
    if (hash) return;
    window.scrollTo({ top: 0, left: 0, behavior: "instant" }); // or "smooth"
  }, [pathname, hash]);

  return null;
}